import React, { ReactNode } from "react";
import { styled } from "styled-components";
import { Content } from "./Content";
import { CardProps } from "./Content/Card";

interface Props {
  children: ReactNode;
  className?: string;
  cardProps?: Omit<CardProps, "children">;
  belowContent?: ReactNode;
  hideAppBar?: boolean;
}

export type LayoutProps = Props;

export const Layout: React.FC<Props> = ({
  cardProps,
  hideAppBar = false,
  ...props
}) => {
  return (
    <Container withMenu={!hideAppBar}>
      <Content cardProps={cardProps} {...props} />
    </Container>
  );
};

type ContainerProps = {
  withMenu?: boolean;
};

const Container = styled.div<ContainerProps>`
  display: grid;
  grid-template-rows: 1fr auto;
  height: 100%;
  width: 100vw;
  position: relative;
`;
